//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VDataTable, VPagination, VProgressLinear } from 'vuetify/lib';
/**
 * Original Author: Josh Porter
 * Original Team: Unidrythons
 *
 * Gitlab file https://code.tls.nuskin.io/ns-am/ux/design-components/-/blob/master/components/ns-table/NsTable.vue
 */
export default {
  name: 'NsTable',
  components: {
    VDataTable,
    VPagination,
    VProgressLinear,
  },
  props: {
    /**
     * An array of objects that each describe a header column. See the example below for a definition of all properties.
     */
    headers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /**
     * The array of table rows
     */
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /**
     * the amount of table rows you want to display at one time. default is 5.
     */
    rows: {
      type: Number,
      default: 5,
    },
    /**
     * Displays linear progress bar. accepts hex values as a string.
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Keeps all expanded content displayed at the same time
     */
    expandAll: {
      type: Boolean,
      default: false,
    },
    /**
     * the field in the item object that designates and unique key.
     */
    itemKey: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      pagination: {
        rowsPerPage: this.rows,
        totalItems: this.items.length,
      },
      expand: this.expandAll,
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  mounted() {
    this.pagination.rowsPerPage = this.rows;
  },
  methods: {
    handleRowClick(slotItemsProps) {
      slotItemsProps.expanded = !slotItemsProps.expanded;
      /**
       * Emits an event when row is clicked with params: function (item){}
       */
      this.$emit('row', slotItemsProps.item);
    },
  },
};
